import Call from '../Call.v2';
import {objToQs} from '../Utils';

const AdkFiveMinFactor = {
    get(filters) {
        return Call(`adk/5MinFactor/?${objToQs(filters)}`);
    },

    getBrowsers(filters) {
        return Call(`adk/5MinFactor/browser?${objToQs(filters)}`);
    },
};

export default AdkFiveMinFactor;



// WEBPACK FOOTER //
// ./src/services/API/components/Adk5MinFactor.js